var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "70 20 360 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield",
    fill: "#663399",
    d: "M96.8805 89.7581L250 43.4749L403.119 89.7581L376.717 342.692L250 456.525L123.278 342.692L96.8805 89.7581Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "flames",
    fill: "#E34D98",
    d: "M201.408 325.01C228.715 333.352 244.399 358.299 251.26 372.272C263.056 344.867 276.224 333.793 287.436 327.176C301.179 319.065 342.6 318.227 347.492 274.201C333.508 300.331 309.102 290.156 328.546 261.238C340.414 243.588 362.69 215.374 335.782 159.831C334.17 176.807 323.313 192.185 287.436 173.152C275 166.555 279.341 156.745 285.029 144.494C292.793 127.773 293.839 109.033 268.126 95.6109C274.489 124.273 268.548 145.451 251.26 136.287C230.674 125.374 234.558 95.3999 247.704 71.5527C229.87 81.1068 192.507 106.377 207.577 125.374C221.432 142.84 215.831 146.99 207.577 159.831C194.456 173.844 165.47 203.912 165.47 168.753C154.769 184.549 133.21 218.691 158.173 247.771C183.136 276.851 177.039 315.953 154.379 280.064C154.379 301.623 154.723 310.749 201.408 325.01Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    fill: "white",
    d: "M188.093 264.265C180.263 256.663 175.398 246.024 175.398 234.248C175.398 211.142 194.129 192.411 217.235 192.411C230.772 192.411 242.806 198.84 250.453 208.811C258.1 198.84 270.135 192.411 283.671 192.411C306.777 192.411 325.508 211.142 325.508 234.248C325.508 246.075 320.6 256.756 312.71 264.366L250.508 327.433L188.093 264.265Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLoader);
export default __webpack_public_path__ + "static/media/shield_loader.9cf0d89121043fcb7fdb0dd286643a9f.svg";
export { ForwardRef as ReactComponent };